import { FC } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { ProductCategory, productCategories } from 'src/utils/constants/ui-constants';

import ProductsForCategory from 'src/components/templates/ProductsForCategory/ProductsForCategory';

const ProductsForCategoryPage: FC = () => {
  const { category } = useParams();
  const title = category === 'custom' ? '맞춤상품' : productCategories[category as ProductCategory];

  return category && title ? <ProductsForCategory category={category} title={title} /> : <Navigate to='/' replace />;
};

export default ProductsForCategoryPage;
